<template>
  <div id="up-button" @click="goTop">
    <div class="wrapper" v-if="showButton">
      <img class="arrow-img" src="/static/icons/UpButton.svg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "UpButton",
  props: {},
  components: {},
  data: () => ({
    showButton: false,
    scrollpx: 0
  }),
  created() {
    if (document.getElementById("router-view")) {
      this.scrollpx = document.getElementById("router-view").scrollTop;
      document
        .getElementById("router-view")
        .addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    if (document.getElementById("router-view")) {
      document
        .getElementById("router-view")
        .removeEventListener("scroll", this.handleScroll);
    }
  },
  watch: {
    scrollpx() {
      if (this.scrollpx > 80) {
        this.showButton = true;
      } else {
        this.showButton = false;
      }
    }
  },
  methods: {
    handleScroll() {
      this.scrollpx = document.getElementById("router-view").scrollTop;
    },
    goTop() {
      document.getElementById("router-view").scrollTop = 0;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#up-button {
  position: fixed;
  bottom: 10px;
  left: 10px;
  cursor: pointer;
  .wrapper {
    border-radius: 50%;
    background: $color-primary;
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    .arrow-img {
      filter: brightness(0) invert(1);
      height: 22px;
      transform: rotate(-90deg);
    }
  }
}
</style>
